import type { IconSvgObject } from './types';

const CompassIcon: IconSvgObject = [
  ["path", { d: "M21.0001 13C21.0001 17.9706 16.9707 22 12.0001 22C7.02956 22 3.00012 17.9706 3.00012 13C3.00012 8.02944 7.02956 4 12.0001 4C16.9707 4 21.0001 8.02944 21.0001 13Z", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 4V2", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M10 2H14", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M7 12L15 9.5L12.5 17.5L11 13.5L7 12Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default CompassIcon;
